import { hrefFor } from '../routers';

export const getVerticalBreadcrumbUrl = (vertical: string) => {
  try {
    return hrefFor.ProductCategoryListingPage({ vertical });
  } catch {
    return hrefFor.HomePage();
  }
};
